import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {Translate} from "../../../../config/Translate";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import axios from "axios";
import {defaultVariabls} from "../../../../config";
import {connect} from "trim-redux";
import TextField from "@material-ui/core/TextField/TextField";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import withWidth from "@material-ui/core/withWidth/withWidth";
import {withSnackbar} from "notistack";
import {withRouter} from "react-router";
import {withStyles} from "@material-ui/core";
import {Styles} from "../../../../config/design/styles";
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import IconButton from "@material-ui/core/IconButton/IconButton";
import Grid from "@material-ui/core/Grid/Grid";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import LoadingButton from "../../../components/elements/LoadingButton";
import ChatRoundedIcon from '@material-ui/icons/ChatRounded';
import Tabs from "@material-ui/core/Tabs/Tabs";
import Tab from "@material-ui/core/Tab/Tab";
import Paper from "@material-ui/core/Paper/Paper";
import Menu from "@material-ui/core/Menu/Menu";
import ButtonGroup from "@material-ui/core/ButtonGroup/ButtonGroup";
import Typography from "@material-ui/core/Typography/Typography";
import SingleFileChooser from "../../fileManager/Components/SingleFileChooser";
class AddTicketModal extends React.Component{
    state = {
        fields:{
            subject:"",
            message:"",
            priority:"medium",
            department:"",
            order_item:""
        },
        receiver:null,
        has_receiver:false,
        type:"system",
        SubmitLoading:false,
        departments:[],
        orderItems:[],
        loading:true,
        open:false,
        errors:{},
        anchorEl:null,
        ticket_file:null
    };
    handleClickMenu = (event) => {
        this.setState({
            anchorEl: event.currentTarget
        })
    };

    handleCloseMenu = () => {
        this.setState({
            anchorEl: null
        })
    };
    async componentDidMount(){
        console.log(this.props.receiver);

        if(!!this.props.receiver){
            await this.setState({
                receiver:this.props.receiver,
                has_receiver:true,
            })
        }
        await this.loadData()
    }
    loadData(){
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.get(`${defaultVariabls.url}/departments/getAllWithOrders`, config)
            .then(response => {
                console.log(response.data)
                this.setState({
                    departments: response.data.departments,
                    orderItems: response.data.order_items,
                    loading:false,
                })
            })
            .catch(error => {
                console.log(error.response)
                this.setState({
                    loading:false
                })
            });
    }
    toggleOpen(type){
        this.setState({
            open: !this.state.open,
            type:type
        })
    }
    handleChange(e){
        let {fields,errors} = this.state;
        let target = e.target;
        errors[target.name] = "";
        fields[target.name] = target.value;
        this.setState({
            fields,
            errors
        });
    }

    handleValidation(callback){
        let { fields,type } = this.state;
        let errors = {};
        let formIsValid = true;

        //subject
        if(!fields.subject) {
            formIsValid = false;
            errors['subject'] = Translate.emptyField;
        }
        //subject
        if(!fields.message) {
            formIsValid = false;
            errors['message'] = Translate.message;
        }
        if(!fields.department) {
            formIsValid = false;
            errors['department'] = Translate.message;
        }
        if(!formIsValid){
            this.props.enqueueSnackbar(Translate.someFieldsHasError, {
                variant: 'warning',
            });
            this.setState({
                SubmitLoading:false,
                errors
            })
        }
        return callback(formIsValid)
    }
    handleRequest(){
        const {fields,type,receiver,ticket_file} = this.state;
        let data = new FormData();
        data.append('subject', fields.subject);
        data.append('message', fields.message);
        data.append('priority', fields.priority);
        data.append('type', type);
        data.append('file_id', !!ticket_file ? ticket_file.id : 0);
        data.append('receiver_id', !!receiver ? receiver.id : '');

        if(type === "system"){
            data.append('department', fields.department);
        }else{
            data.append('order_item', fields.order_item);
        }
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/ticket/add-by-admin`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.ticket_sent, {
                    variant: 'success',
                });
                this.setState({
                    SubmitLoading:false,
                    open:false
                });
                this.props.reload()

            })
            .catch(error => {
                console.log(error)
                this.props.enqueueSnackbar(Translate.detailsSetFailed, {
                    variant: 'error',
                });
                this.setState({
                    SubmitLoading:false
                });
            });
    }
    handleSubmit(e){
        this.setState({
            SubmitLoading:true
        })
        e.preventDefault();
        this.handleValidation((valid) =>{
            if(valid) {
                this.handleRequest();
            }

        });
    }
    render(){
        let {loading,departments,receiver,errors,fields,open,SubmitLoading,ticket_file,anchorEl} = this.state;
        let {user,style} = this.props;
        console.log(receiver)
        return (
            <>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => this.toggleOpen('system')}
                    startIcon={<ChatRoundedIcon/>}
                    size={"small"}
                    style={style}
                >
                    {Translate.addTicket}
                </Button>
                {
                    !loading &&
                    <Dialog
                        open={open}
                        onClose={() => this.toggleOpen()}
                        aria-labelledby="form-dialog-title"
                        fullWidth
                        maxWidth="md"
                    >
                        <DialogTitle id="form-dialog-title">
                            <IconButton
                                onClick={() => this.toggleOpen()}
                                style={{position:"absolute",left:15,top:15}}
                                size="small"
                            >
                                <CloseRoundedIcon fontSize="small"/>
                            </IconButton>
                            {Translate.addTicket}
                        </DialogTitle>
                        <DialogContent>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        disabled
                                        value={receiver.first_name+" "+receiver.last_name}
                                        label={Translate.ticket_receiver}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        select
                                        name="priority"
                                        value={fields.priority}
                                        label={Translate.priority}
                                        onChange={this.handleChange.bind(this)}
                                        error = {!!errors['priority']}
                                        helperText={errors['priority']}
                                    >
                                        <MenuItem value={"low"}>{Translate.low}</MenuItem>
                                        <MenuItem value={"medium"}>{Translate.medium}</MenuItem>
                                        <MenuItem value={"high"}>{Translate.high}</MenuItem>
                                    </TextField>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        select
                                        name="department"
                                        value={fields.department}
                                        label={Translate.department}
                                        onChange={this.handleChange.bind(this)}
                                        error = {!!errors['department']}
                                        helperText={errors['department']}
                                        InputProps={loading &&{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <CircularProgress size={20}/>
                                                </InputAdornment>
                                            ),
                                        }}
                                    >
                                        {
                                            departments.map((department,index)=> (
                                                <MenuItem key={index} value={department.id}>{department.name}</MenuItem>
                                            ))
                                        }

                                    </TextField>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        variant="outlined"
                                        value={fields.subject}
                                        fullWidth
                                        label={Translate.subject}
                                        name="subject"
                                        onChange={this.handleChange.bind(this)}
                                        error = {!!errors['subject']}
                                        helperText={errors['subject']}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        variant="outlined"
                                        value={fields.message}
                                        fullWidth
                                        label={Translate.message}
                                        name="message"
                                        minRows={5}
                                        multiline
                                        onChange={this.handleChange.bind(this)}
                                        error = {!!errors['message']}
                                        helperText={errors['message']}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography>{Translate.attached_file}</Typography>
                                    <SingleFileChooser
                                        initial={ticket_file}
                                        onChange={(file) => this.setState({ticket_file:file})}
                                        type="document"
                                        align="center"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <LoadingButton
                                        variant="contained"
                                        color="primary"
                                        onClick = {this.handleSubmit.bind(this)}
                                        loading = {SubmitLoading}
                                    >
                                        {Translate.addTicket}
                                    </LoadingButton>
                                </Grid>
                            </Grid>
                        </DialogContent>
                    </Dialog>

                }

            </>
        );
    }
}
const mstp = state => ({
    user: state.user,
});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(AddTicketModal)))));